import React, { Component } from 'react';
import { connect } from 'react-redux';
import {withTranslation} from 'react-i18next';
import { withRouter } from 'react-router';

import { callGET, callPOST, callPUT, callDELETE } from '../../Utils/ApiUtil';
import * as ShipConstants from '../../Global/Constants';
import BreadCrumbs from "../../Components/UI/BreadCrumbs";
import * as actions from '../../store/actions'
import { getWindowObjectUsingWindowName } from '../../Utils/UserFunctions';

import ForecastSettings from './ForecastSettings';
import NewForecast from './NewForecast';
import ViewForecast from './ViewForecast';
import {findFieldWithFilterByName,getSelectedValueBasedOnField,deleteViolationsMsg} from '../../Utils/CommonFunctions';
import {getUserInfo,getProfileAuthorities} from '../../Utils/UserFunctions';
import Icons from '../../Components/Icons/Icons'

class ForecastContainer extends Component {
  _isMounted = false;
  state ={
  	forecastSettings : null,
  	forecastSettingsModel : false,
    newForecastModel : false,
    editTerritoryModel : false,
    editSubTerritoryModel : false,
    editTerritoryUserModel : false,
    editData : null,
    windowFields : null,
    territoryList : null,
    roleList:null,
    userList:null,
    forecastData : null,
    isList : false,
    lastEid : '',
    lastUid : '',
    forecastsSetting_formsfields : {
      hierarchy_type : '',
      target_period : '',
      begin_month : 1,
      year_reference : 0,
      target_tabledescriptor_id : ''
    },
    forecast_searchform : {
      element_id : '',
      month : '',
      year : ''
    },
    tableRecords:{
      selectedRows:[],
      gridList:[],
      layoutAddType:0,
      isAchieved : '',
      eid : '',
      uid : '',
      tableHead:[],
      tableData:[], 
      pagination:{
        page:0,
        orderBy:'',
        perPage:10,
        direction:'ASC',
        totalRecords:0,
        search:'',
        viewType:'LIST',
      },
      gridFilter:{},
      columnSort :{}
    },
    violations: null
  }

  componentDidMount() {
    const windowData = getWindowObjectUsingWindowName("Opportunity");
    // console.log(windowData.window_id);
    this.generateFields(windowData.window_id);
  	// this.viewForecastSettings();
    // this.territoryList();
    this.rolesList();
  }

  generateFields = (windowId) => {
    this.props.Loader();
    const body = {
      window_info : {
        window_id : windowId,
        related_window : []
      }
    }
    callPOST("field-groups/window/related-windows/fields",body)
      .then(response => {
        this.props.Loader();
        // const currentYear = (new Date()).getFullYear();
        // const month = (new Date()).toLocaleString('default', { month: 'short' }).toUpperCase();
        const responseData = response.data;
        const updateState = {...this.state}
        // updateState['forecast_searchform']['month'] = month;
        // updateState['forecast_searchform']['year'] = currentYear;
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
            updateState.windowFields = responseData.data;
        }else {
          updateState.windowFields = null;
        }
        this.setState(updateState);
        /*setTimeout(() => {
          this.getForecast();
        }, 200);*/
      })
      .catch(err => {
        this.props.Loader();
        console.log("error occured",err);
      });
  }

  viewForecastSettings = () => {
    callGET('forecasts/settings/view')
      .then(response => {
          // console.log("response",response);
          const responseData = response.data;
          if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
            const dataVal = responseData.data;
            const updateState = {...this.state}
            updateState.forecastSettings = responseData.data;
            updateState.forecastSettingsModel = false;
            if(dataVal.id !== null){
              updateState['forecastsSetting_formsfields']['hierarchy_type'] = dataVal.hierarchy_type;
              updateState['forecastsSetting_formsfields']['target_period'] = dataVal.target_period;
              updateState['forecastsSetting_formsfields']['begin_month'] = dataVal.begin_month;
              updateState['forecastsSetting_formsfields']['year_reference'] = dataVal.year_reference;
              updateState['forecastsSetting_formsfields']['target_tabledescriptor_id'] = dataVal.target_tabledescriptor_id;
            }
            this.setState(updateState);
          }
      }, (error) => {
          console.log(error);
      }) 
  }

  rolesList = () => {
    const currentYear = (new Date()).getFullYear();
    const month = (new Date()).toLocaleString('default', { month: 'short' }).toUpperCase();


    callGET('forecasts/settings/view')
    .then(forResponse => {
        // console.log("response",response);
        const forResponseData = forResponse.data;
        if(forResponseData.code === ShipConstants.API_STATUS_SUCCESS) {
          callGET("roles/view")
          .then(res => {
              const roleResponse = res.data;
              if(roleResponse.code===200){
                callGET('territory/view')
                .then(response => {
                    const updateState = {...this.state};
                    const dataVal = forResponseData.data;
                    updateState.forecastSettings = forResponseData.data;
                    updateState.forecastSettingsModel = false;
                    if(dataVal.id !== null){
                      updateState['forecastsSetting_formsfields']['hierarchy_type'] = dataVal.hierarchy_type;
                      updateState['forecastsSetting_formsfields']['target_period'] = dataVal.target_period;
                      updateState['forecastsSetting_formsfields']['begin_month'] = dataVal.begin_month;
                      updateState['forecastsSetting_formsfields']['year_reference'] = dataVal.year_reference;
                      updateState['forecastsSetting_formsfields']['target_tabledescriptor_id'] = dataVal.target_tabledescriptor_id;
                    }
                    updateState.roleList = roleResponse.data;
                    updateState['forecast_searchform']['month'] = month;
                    updateState['forecast_searchform']['year'] = currentYear;
                    const responseData = response.data;
                    if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
                      updateState.territoryList = responseData.data;
                    }else {
                      updateState.territoryList = null;
                    }
                    this.setState(updateState);
                    if(forResponseData.data.id) {
                      this.userList(roleResponse.data.id);
                      setTimeout(() => {
                        if(forResponseData.data) {
                          if(forResponseData.data.has_territory_enabled) {
                            this.getForecast('',JSON.stringify({'territory_hierarchy':responseData.data}));
                          }else {
                            this.getForecast('',JSON.stringify({'role_hierarchy':roleResponse.data}));
                          }
                        }
                        
                      }, 200);
                    }
                }, (error) => {
                    console.log(error);
                    const updateState = {...this.state};
                    updateState.territoryList = null;
                    updateState.roleList = roleResponse.data;
                    updateState['forecast_searchform']['month'] = month;
                    updateState['forecast_searchform']['year'] = currentYear;
                    this.setState(updateState);

                    setTimeout(() => {
                      this.getForecast('',JSON.stringify({'role_hierarchy':roleResponse.data}));
                    }, 200);
                })
              }
          })
        }
      }, (error) => {
          console.log(error);
      }) 
  }  

  /*territoryList = () => {
    callGET('territory/view')
      .then(response => {
          const updateState = {...this.state};
          const responseData = response.data;
          if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
            updateState.territoryList = responseData.data;
          }else {
            updateState.territoryList = null;
          }
          this.setState(updateState);
      }, (error) => {
          console.log(error);
          const updateState = {...this.state};
          updateState.territoryList = null;
          this.setState(updateState);
      })
  }

  //ROLES LIST 
  rolesList = () => {
      callGET("roles/view")
      .then(res => {
        if(res.status===200){ 
          const response = res.data;
          if(response.code===200){
            // console.log("roles/view",JSON.stringify(response.data));
             const updateState = { ...this.state };
             updateState.roleList = response.data;
             this.setState(updateState);
             if(response.data.id)
              this.userList(response.data.id);
          }
        }
      })
  }  */

  toggleForecastSettings = () => {
  	const updateState = {...this.state}
  	updateState.forecastSettingsModel = !updateState.forecastSettingsModel;
    updateState.violations = null;
  	this.setState(updateState);
  }

  forecastSettingsChangeHandler = (e) => {
    const {name,value} = e.target;
    const updateState = {...this.state}
    if(name === 'begin_month') {
      if(parseInt(value) === 1)
        updateState['forecastsSetting_formsfields']['year_reference'] = 0;
    }
    updateState['forecastsSetting_formsfields'][name] = value;

    if(this.state.violations) {
      let viol = this.state.violations;
      if(name === 'begin_month') {
        viol = deleteViolationsMsg('beginMonth',this.state.violations);
      }else if(name === 'target_tabledescriptor_id') {
        viol = deleteViolationsMsg('targetTableDescriptorId',this.state.violations);
      }
      updateState['violations'] = viol;
    }
    this.setState(updateState);
  }

  saveForcastSettings = () => {
    this.props.Loader();
    const formFields = this.state.forecastsSetting_formsfields;
    const forecastSettings = this.state.forecastSettings;
    const forcastId = this.state.forecastSettings ? this.state.forecastSettings.id : null;
    const body = {
      hierarchy_type : forecastSettings ? forecastSettings.has_territory_enabled === true ? 1 : 0 : 0,
      target_period : formFields.target_period,
      begin_month : formFields.begin_month,
      year_reference : formFields.year_reference,
      target_tabledescriptor_id : formFields.target_tabledescriptor_id
    }

    console.log(JSON.stringify(body));
    if(forcastId) {
      callPUT('forecasts/settings/update',body)
      .then(response => {
        this.props.Loader();
        // console.log("response",response);
        const responseData = response.data;
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
          this.props.succMessage(responseData.message);
          this.viewForecastSettings();
        }else {
          let viol = {};
          let errMsg = '';
          if(responseData.violations) {
            responseData.violations.map((arr,ind) => {
              const data = arr.field_name+':'+arr.message;
              viol[arr['field_name']]= arr['message'];
              errMsg += ind === 0 ? data : '<br />'+data;
            })
            this.setState({violations:viol});
          }
          this.props.failMessage(responseData.message+"<br/>"+errMsg);
        }
      }, (error) => {
        this.props.Loader();
        this.props.failMessage("Error occured");
        console.log(error);
      })  
    }else {
      callPOST('forecasts/settings/create',body)
        .then(response => {
          this.props.Loader();
          // console.log("response",response);
          const responseData = response.data;
          if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
            this.props.succMessage(responseData.message);
            this.viewForecastSettings();
          }else {
            let viol = {};
            let errMsg = '';
            if(responseData.violations) {
              responseData.violations.map((arr,ind) => {
                const data = arr.field_name+':'+arr.message;
                viol[arr['field_name']]= arr['message'];
                errMsg += ind === 0 ? data : '<br />'+data;
              })
              this.setState({violations:viol});
            }
            this.props.failMessage(responseData.message+"<br/>"+errMsg);
          }
        }, (error) => {
          this.props.Loader();
          this.props.failMessage("Error occured");
          console.log(error);
        })  
    }
  }

  toggleNewForecast = () => {
    const updateState = {...this.state}
    updateState.newForecastModel = !updateState.newForecastModel;
    this.setState(updateState);
  }

  searchFormChangeHandler = (e) => {
    const {name,value} = e.target;
    const updateState = {...this.state}
    updateState['forecast_searchform'][name] = value;
    this.setState(updateState);
  }

  getForecast = (id="",child='', userId="") => {
    const seatchData = this.state.forecast_searchform;
    const childData = JSON.parse(child);
    console.log(childData);
    let elementID = seatchData.element_id;
    if(id !== '') {
      elementID = id;
    }
    const month = seatchData.month;
    const year = seatchData.year;

    const body = childData;

    const queryString = '?eid='+elementID+'&uid='+userId+'&spd='+month+'&syr='+year;
    callPUT('forecasts/view'+queryString,body)
      .then(response => {
        const updateState = {...this.state};
        const responseData = response.data;
        updateState.isList = false;
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
          updateState.lastUid = userId;
          updateState.lastEid = id;
          updateState.forecastData = responseData.data;
          updateState.forecast_searchform.element_id =elementID;
          this.userList(elementID);
        }else {
          updateState.forecastData = null;
        }
        this.setState(updateState);
      }, (error) => {
          console.log(error);
      })
  }

  userList = (elementID) => {
    callGET('forecasts/list-users?eid='+elementID)
      .then(response => {
        const updateState = {...this.state};
        const responseData = response.data;
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
          updateState.userList = responseData.data;
        }else {
          updateState.userList = null;
        }
        this.setState(updateState);
      }, (error) => {
          console.log(error);
      })
  }

  toggleEditTerritory = (editData) => {
    console.log('toggleEditTerritory',editData);
    const updateState = {...this.state}
    updateState.editTerritoryModel = !updateState.editTerritoryModel;
    if(editData !== undefined) {
      updateState.editData = JSON.parse(editData);
    }else {
      updateState.editData = null;
    }
    this.setState(updateState);
  }

  toggleEditSubTerritory = (editData) => {
    console.log('toggleEditSubTerritory',editData);
    const updateState = {...this.state}
    updateState.editSubTerritoryModel = !updateState.editSubTerritoryModel;
    if(editData !== undefined) {
      updateState.editData = JSON.parse(editData);
    }else {
      updateState.editData = null;
    }
    this.setState(updateState);
  }  

  toggleEditTerritoryUser = (editData) => {
    console.log('toggleEditTerritoryUser',editData);
    const updateState = {...this.state}
    updateState.editTerritoryUserModel = !updateState.editTerritoryUserModel;
    if(editData !== undefined) {
      updateState.editData = JSON.parse(editData);
    }else {
      updateState.editData = null;
    }
    this.setState(updateState);
  }  

  editTerritoryChangeHandler = (e,ind) => {
    const {name,value} = e.target;
    const updateState = {...this.state}
    updateState['editData'][ind][name] = value;
    console.log(updateState['editData']);
    this.setState(updateState);
  }

  updateHandler = (name) => {
    this.props.Loader();
    const editData = this.state.editData;
    const forecastData = this.state.forecastData;
    const elementID = this.state.forecast_searchform.element_id;
    let hierData = [];
    editData.map((arr,i) => {
      let val = '';
      if(name === 'users') {
        val = {
          id : arr.id,
          user_id : arr.user_id,
          is_manager : arr.is_manager,
          element_id : arr.element_id,
          target_value : arr.target_value
        }
      }else {
        val = {
          id : arr.id,
          element_id : arr.element_id,
          parent_id : arr.parent_id,
          target_value : arr.target_value
        }
      }
      
      hierData.push(val);
    })

    let body = {}
    if(name === 'users') {
      body = { user_forecasts : hierData }
    }else {
      body = { hierarchy_forecasts : hierData }
    }
    
    console.log(JSON.stringify(body));
    callPUT("forecasts/"+forecastData.id+"/update",body)
      .then(response => {
        this.props.Loader();
        console.log(response);
        const responseData = response.data;
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
          this.props.succMessage(responseData.message);
          const updateState = {...this.state}
          updateState.editTerritoryModel = false;
          updateState.editSubTerritoryModel = false;
          updateState.editTerritoryUserModel = false;
          this.setState(updateState);
          const forecastSettingsData = updateState.forecastSettings;
          const hasTerritory = forecastSettingsData ? forecastSettingsData.has_territory_enabled : false;
          if(hasTerritory) {
            this.getForecast('',JSON.stringify({territory_hierarchy:this.state.territoryList}))
          }else {
            this.getForecast(this.state.roleList.id,JSON.stringify({role_hierarchy:this.state.roleList}))
          }
          
        }else {
          this.props.failMessage(responseData.message);
        }
      })
      .catch(err => {
        this.props.Loader();
        this.props.failMessage("Error occured");
        console.log(err);
      })
  }

  deleteForecast = (ide) => {
    console.log("ide",ide);
    this.props.Loader();
    const forecast_searchform = this.state.forecast_searchform;
    let isDelete = window.confirm("Delete ForecastJIIT \nYou are about to delete the Forecast of your Organization for the period of "+forecast_searchform.month+", "+forecast_searchform.year+". \nPlease be aware of the following things moving forward: \nAll the Forecasts of the child territories will be deleted permanently. \nAll the users' Forecasts across the organization will also be deleted.");
    if(isDelete) {
      callDELETE("forecasts/"+ide+'/delete')
      .then(response => {
        this.props.Loader();
        const responseData = response.data;
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
          this.props.succMessage(responseData.message);
          const forecastSettingsData = this.state.forecastSettings;
          const hasTerritory = forecastSettingsData ? forecastSettingsData.has_territory_enabled : false;
          if(hasTerritory) {
            this.getForecast('',JSON.stringify({territory_hierarchy:this.state.territoryList}))
          }else {
            this.getForecast(this.state.roleList.id,JSON.stringify({role_hierarchy:this.state.roleList}))
          }
          // this.getForecast('',JSON.stringify({territory_hierarchy:this.state.territoryList}))
        }else {
          this.props.failMessage(responseData.message);
        }
      })
      .catch(err => {
        this.props.Loader();
        this.props.failMessage("Error occured");
        console.log(err);
      })
    }
  }

  //call opportunity module
  getDeals1 = (pagination) => {
    const tableRecords = this.state.tableRecords;
    const isAchieved = tableRecords.isAchieved;
    const eid = tableRecords.eid;
    const uid = tableRecords.uid;
    this.getDeals(pagination,isAchieved,eid,uid);
  } 

  //LAYOUTS LIST 
  getDeals = (pagination,isAchieved,eid,uid,name='') => {
    this.props.Loader();
    const page = pagination.page; 
    const orderBy = pagination.orderBy; 
    // const perPage = pagination.perPage; 
    const direction = pagination.direction; 
    const search = pagination.search;
    const viewType = pagination.viewType;
    const perPage = pagination.perPage;
    this.setState({
      isList : true,
      tableRecords:{
        ...this.state.tableRecords,
        isAchieved : isAchieved,
        eid : eid,
        uid : uid,
        terrName : name,
        pagination:pagination
      }
    })

    const seatchData = this.state.forecast_searchform;
    let elementID = seatchData.element_id;
    let forecastData = this.state.forecastData;

    const queryString = '?achieved='+isAchieved+'&eid='+eid+'&uid='+uid+'&sdt='+forecastData.start_date+'&edt='+forecastData.end_date+'&query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction;

    callGET('forecasts/Opportunity/filter-data'+queryString)
    .then(res => {
      this.props.Loader();
      if(res.status===200){ 
        const response = res.data;
        if(response.code===200){
            this.setState({tableRecords:{
                ...this.state.tableRecords,
                gridList:response.data.grid_list
            }});
            const actionComponents = response.data.actionComponents;
            const layout_type = response.data.layout_type;
            const html_code = response.data.html_code;
            const actionBtn = {};
            let returnData = this.formTableGridJSON(response.data.value_list,actionBtn);
            console.log(returnData);
            const totalRecords = response.data.value_list.total_elements;
            const default_grid_view = response.data.user_grid_view_preference.default_grid_view;
            this.setState({status:200,gridView:default_grid_view,assignRulesModel:false,tableRecords:{
              ...this.state.tableRecords,
              tableData:{data:returnData['updateTableData'],status:(totalRecords>0)?200:400},
              tableHead:returnData['tablehead'],
              selectedRows:this.state.tableRecords.selectedRows,
              gridList:response.data.grid_list,
              layoutAddType:response.data.layout_type,
              // html_code:response.data.html_code,
              pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords,viewType:default_grid_view}
            }});
          
          
        }else{
          const totalRecords = 0;//response.data.totalElements;
          this.setState({status:200,assignRulesModel:false, tableRecords:{
            tableData:{data:[],status:400},
            isAchieved : '',
            eid : '',
            uid : '',
            terrName : '',
            gridList:[],
            layoutAddType:0,
            selectedRows:this.state.tableRecords.selectedRows,
            tableHead:this.state.tableRecords.tableHead ,
            pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
          }});
        }
      }
    }, (error) => {
        console.log(error);
        this.props.Loader();
        this.props.failMessage("Something went wrong..");
      })
  }  


  formTableGridJSON = (value_list,actionBtn)=>{
      const windowData = getWindowObjectUsingWindowName("Opportunity");
      const data = this.getWindowDataUsingId(windowData.window_id);
      console.log(data);
      let inc = 0;
      const params = this.props.match.params;
      let updateTableData = [];  
      let actionBtnEachRecord = {};
      let fieldsRow = {};
      let fieldsRow1 = {};
      let returnData = [];
      let tablehead =[]
      this.state.tableRecords.gridList.map((header,headerIndex)=>{
        if(headerIndex <=4 ) {
            tablehead.push({
                name:header.display_name,
                type:"HyperLink",
                isShow:header.is_show,
                columnId:header.table_descriptor_id,
                isSort : true,
                attributes : {
                  class: header.table_descriptor_id + " sortColumns",
                }
                                      
              });
          }
      })    
      const selectedRows = this.state.tableRecords.selectedRows;  
      value_list.content.map((contentData)=>{
        fieldsRow = {}
        inc++;
          tablehead.map((column,tIndex)=>{
           /* if(tIndex>0){
                fieldsRow = {
                    ...fieldsRow,
                    [column.columnId]:{
                      clickHandler:(tIndex<3)?this.goToDetailViewHandler.bind(
                        this,
                        "/layouts/"+params.windowName+"/"+params.windowId+"/detailView/"+params.layoutId+"/"+contentData.meta_table_id+""
                        ):"",
                        className:(tIndex<3)?'primary_color cursor-pointer':'',
                        value:""
                    },
                } 
            }*/
          })
          tablehead.map((column,tIndex)=>{

            contentData.fields.map((item)=>{
              if(item.table_descriptor_id===column.columnId){
              tablehead = [...tablehead].map((column)=>{
                if(item.table_descriptor_id===column.columnId){
                  column.type = (item.element_type!=='ImageUpload')?'HyperLink':'Image';
                }
                return column;
              });
              item.selectedValue = item.value;
              item.element = (item.element_type==='PickList')?'TextInput':item.element_type;
              item.options = [];
              fieldsRow = {
                  ...fieldsRow,
                  [item.table_descriptor_id]:{ 
                    ...fieldsRow[item.table_descriptor_id],  
                    value:getSelectedValueBasedOnField(item),

                    clickHandler:(tIndex<3)?this.goToDetailViewHandler.bind(
                        this,
                        "/layouts/Opportunity/"+data.window_id+"/detailView/"+data.layout_id+"/"+contentData.meta_table_id+""
                        ):"",
                        className:(tIndex<3)?'primary_color cursor-pointer':'',
                  },
              }
            }
            });
          });

          updateTableData.push({
            className:'',
            rowId:contentData.meta_table_id,
            data:fieldsRow
          });
      });
    returnData['updateTableData'] = updateTableData;
    returnData['tablehead'] = tablehead;
    return returnData; 
  }  

  getWindowDataUsingId = (id) => {
    let data = {};
    const profileInfo = getProfileAuthorities();
    console.log(profileInfo.data.user_profile_layout);
    // profileInfo.map((arr,ind) => {
      // if(arr.user_profile_layout) {
        profileInfo.data.user_profile_layout.map((arr1,ind1) => {
          if(arr1.window_id === id) {
            data = arr1;
          }
        })
      // }
    // })
    return data;
  }  

  goToDetailViewHandler = (url)=>{
    this.props.history.push(url);
  }   

  render() {
    // console.log(this.state.selectedFolderId);
    const  breadCrumbs = {
      backHistory : [{
        href : "/settings",
        name:"Settings"
      }],
      pageTitle: "Forecast",
 	    buttonList:[{
        href:"",
        clickHandler : this.toggleForecastSettings,
        name: "Forecast Settings",
        attributes:{
          className:"btn secondary_bg mr-2"
        },
        type:"cancel",
        icon:"fas fa-plus smoky_light_color",
      },
      {
        href:"",
        name:"Add New", 
        clickHandler : this.toggleNewForecast,
        attributes:{
          className:"btn primary_bg"          
        },
        svgIcon:"AddPlus",
        type:"save",
        icon:"",
      }]
    }

    return (
      <>
      <BreadCrumbs breadCrumbsList={breadCrumbs}/>
    <div className="viewport">
        <div className="view view-xl" id="wrapper">
          {/* <div className="view view--hor-scroll ember-view entity-list-view"> */}
            
            <div className="portTwoSection">
              <ViewForecast 
                {...this.props}
                curState={this.state}
                searchFormChangeHandler={this.searchFormChangeHandler}
                getForecast={this.getForecast}
                userList={this.userList}
                toggleEditTerritory={this.toggleEditTerritory}
                toggleEditSubTerritory={this.toggleEditSubTerritory}
                editTerritoryChangeHandler={this.editTerritoryChangeHandler}
                editSubTerritoryChangeHandler={this.editSubTerritoryChangeHandler}
                updateHandler={this.updateHandler}
                toggleEditTerritoryUser={this.toggleEditTerritoryUser}
                deleteForecast={this.deleteForecast}
                toggleNewForecast={this.toggleNewForecast}
                getDeals = {this.getDeals}
                getDeals1 = {this.getDeals1}
              />  
            </div>
            
          {/* </div> */}
        </div>
        <ForecastSettings
        	curState={this.state}
        	modelOpen={this.state.forecastSettingsModel}
        	toggleModel={this.toggleForecastSettings}
          forecastSettingsChangeHandler={this.forecastSettingsChangeHandler}
          saveForcastSettings={this.saveForcastSettings}
        />

        <NewForecast
          {...this.props}
          curState={this.state}
          modelOpen={this.state.newForecastModel}
          toggleModel={this.toggleNewForecast}
          userList={this.userList}
        />
    </div>
    </>
	)
 }
}

const mapStateToProps = state => {
  return {
    authenticated: state,
    loading : state.commonReducer.loading,
  };
}

const mapDispatchToProps = dispatch => {
  return {
    Loader : () => dispatch(actions.loader()),
    succMessage : (msg) => dispatch(actions.succMessage(msg)),
    failMessage : (msg) => dispatch(actions.failMessage(msg))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(ForecastContainer)));